import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import newlogo from "./../../assets/Images/sign-in-logo.svg";
import GlobalLoader from "../shared/GlobalLoader";
import hide from "./../../assets/Images/hide.svg";
import noHide from "./../../assets/Images/noHide.svg";
import useEmailValidation from "../../hooks/useEmailValidation";
import usePostData from "../Custom-Hooks/usePostData";
import axios from "axios";
import SuccessPopup from "../shared/SuccessPopup";

const Login = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { email, emailError, setEmail } = useEmailValidation();
  const {
    email: forgotEmail,
    emailError: forgotEmailError,
    setEmail: setForgotEmail
  } = useEmailValidation();

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const navigate = useNavigate();
  const { response, isLoading, error, post } = usePostData(`${baseUrl}/auth/login`);
  const [stateLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem('theme', 'light');
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    await post({ email: email, password });
  };

  useEffect(() => {
    if (response?.status?.toLowerCase() == 'success') {
      localStorage.setItem("email", response?.data?.email);
      localStorage.setItem("firstname", response?.data?.firstname);
      localStorage.setItem("lastname", response?.data?.lastname);
      localStorage.setItem("role_id", response?.data?.role_id);
      localStorage.setItem("role_name", response?.data?.role_name);
      localStorage.setItem("id", response?.data?.id);
      sessionStorage.setItem("accessToken", response?.data?.tokens?.accessToken);
      if (response?.data?.role_name !== 'Admin') {
        localStorage.setItem("customerId", response?.data?.customer?.id);
      }

      const userDetails = {
        email: response?.data?.email,
        firstname: response?.data?.firstname,
        lastname: response?.data?.lastname,
        role_id: response?.data?.role_id,
        role_name: response?.data?.role_name,
        id: response?.data?.id,
        customerId: response?.data?.role_name !== 'Admin' ? response?.data?.customer?.id : null,
      };
      localStorage.setItem("userDetails", JSON.stringify(userDetails));


      navigate("/facility");
    }
    if (error) {
      setErrorMessage((error?.message) ? error?.message : "Something went wrong !!!");
    }
  }, [response, error, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError(null);

    if (!forgotEmailError) {
      setIsLoading(true);

      try {
        const response = await axios.patch(`${baseUrl}/auth/forget-password`,
          { email: forgotEmail }
        );

        if (response.status === 200) {
          setShowPopup(true);
        }
      } catch (error) {
        setApiError(error.response?.data?.message || "Failed to send reset link.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div className="login-wrapper">
      {isLoading && <GlobalLoader />}
      <div className="login-overlay">
        <div className="container-fluid h-100 d-flex justify-content-around align-items-center flex-wrap trans-bg">
          {showForgotPassword ?
            <div className="login-form-box bg-white p-4 rounded shadow" style={{ maxWidth: "400px", width: "100%" }}>
              <h5 className="text-center my-2 fw-600">Forgot Password</h5>
              <h6 className="mb-4 text-center fnt13">Enter your email to reset your password</h6>
              <form onSubmit={handleSubmit}>
                <div className="mb-4 text-dark">
                  <label htmlFor="forgotEmail" className="form-label fnt12">Email</label>
                  <input
                    type="text"
                    id="forgotEmail"
                    placeholder="admin@cedar.com"
                    className="form-control login-input"
                    value={forgotEmail}
                    onChange={(e) => setForgotEmail(e.target.value)}
                    required
                  />
                  {forgotEmailError && <span className="text-danger fnt13">{forgotEmailError}</span>}
                  {apiError && <span className="text-danger fnt13">{apiError}</span>}
                </div>
                <div className="d-flex gap-3">
                  <button type="submit" className="btn btn-primary w-50" disabled={stateLoading || !!forgotEmailError}>
                    {stateLoading ? "Submitting..." : "Submit"}
                  </button>
                  <button type="button" className="btn btn-secondary w-50" onClick={() => setShowForgotPassword(false)}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
            :
            <div className="login-form-box bg-white p-4 rounded shadow" style={{ maxWidth: "400px", width: "100%" }}>
              <h5 className="text-center my-2 fw-600">Sign In</h5>
              <form onSubmit={handleLogin}>
                <div className="mb-2 text-dark">
                  <label htmlFor="email" className="form-label fnt12">
                    Email
                  </label>
                  <input type="text" id="email" placeholder="admin@cedar.com" className="form-control login-input" value={email} onChange={(e) => setEmail(e.target.value)} required />
                  {emailError && <span className="text-danger fnt13">{emailError}</span>}
                </div>
                <div className="mb-2 position-relative">
                  <label htmlFor="password" className="form-label fnt12">
                    Password
                  </label>
                  <div className="position-relative">
                    <input
                      type={!showPassword ? "password" : "text"}
                      id="password"
                      placeholder="***********"
                      className="form-control login-input pe-5"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <img
                      src={showPassword ? noHide : hide}
                      className="position-absolute top-50 translate-middle-y end-0 me-3 cr-cursor-pointer"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: "pointer", width: "20px", height: "20px" }}
                      alt="Toggle password visibility"
                    />
                  </div>
                </div>

                {errorMessage && (
                  <div className="text-danger mb-3">{errorMessage}</div>
                )}
                <button type="submit" className="btn btn-primary w-100 mt-2" disabled={!!emailError}> {" "} Sign In{" "} </button>
                <div className="mt-1 text-end">
                  <button type="button" className="btn btn-link decoration-none fnt12" onClick={() => setShowForgotPassword(true)}>
                    Forgot Password?
                  </button>

                </div>
              </form>
            </div>
          }

          <div className="text-center text-white mt-4 mt-lg-0 ms-lg-5">
            <img src={newlogo} alt="Cold Core Logo" className="img-fluid" style={{ maxWidth: "22vw" }} />
          </div>
        </div>
      </div>
      <SuccessPopup
        type=""
        show={showPopup}
        message="We have sent a password reset link to your registered email ID"
        onClose={() => setShowPopup(false)}
      />
    </div>
  );
};

export default Login;
